export default __webpack_public_path__ + "static/nextgen-banner-3-2e75e618f6d4de358c0e381e1fb14b1a.webp";